<template>
  <v-autocomplete :value="value" :disabled="disableSearch" :items="localItems" :item-value="prop" item-text="localDescription" :label="text" :filter="filterFnc" :rules="rules" @input="itemSelected">
    <template v-slot:item="{ item }">
      <v-list-tile-content>
        <v-list-tile-title>{{ item.customerNumber }} - {{ item.facilityName }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ item.city }}/{{ item.state }}/{{ item.zip }} - {{ item.addressLine1 }}</v-list-tile-sub-title>
        <v-list-tile-sub-title>{{ item.email }} - {{ item.contactNumber }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: ['value', 'items', 'filterFnc', 'prop', 'text', 'textFnc', 'rules','disableSearch'],
  computed: {
    localItems() {
      if (!this.textFnc)
        return this.items;
      return (this.items || [])
        .map(f => ({ ...f, localDescription: this.textFnc ? this.textFnc(f) : f[this.prop] }))
    },
  },
  methods: {
    itemSelected(event) {
      var selected = this.items.find(f => f[this.prop] === event);
      this.$emit('input', selected);
    },
  }
}
</script>